import { useQuery } from '@tanstack/react-query';

import StatusCode from 'status-code-enum';
import {
  getApiV2CustomersCustomerIdTags,
  type PaginatedCustomerTagListList as CustomerTagsResponse,
} from '@hungryroot/rest/api/v2/customers/[id]/tags/get';

export const getCustomerTagsQueryKey = (tagIn?: number[]) => [
  'customer_tags_from_set',
  tagIn
    // Because these will normally come straight from the API, we want to ensure we have a consistent order
    ?.sort((a, b) => a - b)
    .map((tag) => tag.toString())
    .join(',') ?? 'all',
];

const timeLimit = 5 * 60 * 1000;

/** Get the preferences a customer has for an explicit set of tags */
export function useCustomerTags(
  tagIn: number[] | undefined,
  options?: {
    enabled?: boolean;
    refetchInterval?: Parameters<
      typeof useQuery<CustomerTagsResponse>
    >[0]['refetchInterval'];
  }
) {
  return useQuery({
    queryKey: getCustomerTagsQueryKey(tagIn),
    queryFn: async () => {
      const resp = await getApiV2CustomersCustomerIdTags({
        customerId: 'self',
        tagIn,
        limit: tagIn?.length,
      });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled !== false && !!tagIn,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
